import type { CampoDecimalProps } from "./types-campo-decimal";
import { useCampoDecimal } from "./use-campo-decimal";
import { CampoDecimalView } from "./view-campo-decimal";

export function CampoDecimal(props: CampoDecimalProps) {
  const vm = useCampoDecimal(props);

  return <CampoDecimalView {...vm} />;
}

export type * from "./types-campo-decimal";
export type { CasasDecimais } from "./campo-decimal.mascara";
